/* eslint-disable  */
//@ts-nocheck

import { useQuery } from '@apollo/client';
import { GET_INFLUENCER } from '../api/graphql/query';
import React from 'react';
import _ from 'underscore';
import { Link } from 'react-router';

import auth from './auth';
import ajax from './ajax';
import helpers from './helpers';
import * as enums from '@playbook-technologies/common-enums';

import Icons from './Icons';
import Header from './Header';
import createClass from 'create-react-class';
import { Typography } from '@mui/material';
import { TitledPage } from '@client/new/components/Misc';
import circuitIcon from '/static/images/circuit-icon.svg';

const ExerciseTemplateList = createClass({
  getInitialState() {
    return {
      exerciseTemplates: [],
      message: 'Loading...',
    };
  },
  getInfluencerId() {
    let influencerId = this.props.params.influencerId
      ? this.props.params.influencerId
      : auth.getUser().influencerId;
    return influencerId;
  },
  async componentDidMount() {
    let influencerId = this.getInfluencerId();
    this.refreshExerciseTemplates(influencerId);
  },
  onChange() {
    let influencerId = this.getInfluencerId();
    this.refreshExerciseTemplates(influencerId);
  },
  refreshExerciseTemplates(influencerId) {
    ajax
      .getExerciseTemplates(influencerId)
      .then((data) => {
        console.log(data);
        const filterOutYoutubeType = data.filter((e) => e.type !== 4);
        this.setState({
          exerciseTemplates: filterOutYoutubeType,
          message: '',
        });
      })
      .catch((e) => {
        if (e === 'auth') {
          auth.logout();
        } else {
          this.setState({
            message: 'You may be experiencing connectivity issues.',
          });
        }
      });
  },
  render() {
    //console.log('[ExerciseTemplateList] render() called.');

    let influencerId = this.getInfluencerId();

    let listItems = _.map(this.state.exerciseTemplates, (et) => {
      return (
        <ExerciseTemplateListItem
          template={et}
          key={et.id}
          onChange={this.onChange}
          params={this.props.params}
          influencerId={influencerId}
        />
      );
    });

    const title = 'Exercise Library';

    const rightPanel = (
      <div className="flex gap-3 justify-center items-center">
        <label>Add to Library:</label>
        <Link
          to={`/admin/exercise-library/0/edit/${influencerId}/${enums.Exercise.Type.Single.value}`}
        >
          {Icons.getExerciseIcon(enums.Exercise.Type.Single.value)}
        </Link>
        <Link
          to={`/admin/exercise-library/0/edit/${influencerId}/${enums.Exercise.Type.Multiple.value}`}
        >
          <img src={circuitIcon} className="w-6 h-6"></img>
        </Link>
      </div>
    );

    return (
      <TitledPage title={title} rightContent={rightPanel}>
        <main id="main">
          <div>
            <br />
            <ol className="workouts-list exerciseTemplateList">{listItems}</ol>
          </div>
        </main>
      </TitledPage>
    );
  },
});

var ExerciseTemplateListItem = createClass({
  deleteExerciseTemplate(id) {
    let answer = confirm(
      'Are you sure you want to *delete* this Library item?',
    );
    if (answer) {
      ajax
        .deleteExerciseTemplate(id)
        .then(() => {
          console.log(
            '[ExerciseTemplateListItem] Deleted ExerciseTemplate.',
            id,
          );
          this.props.onChange();
        })
        .catch((e) => {
          console.log(
            '[ExerciseTemplateListItem] Error deleting ExerciseTemplate.',
            e,
          );
          if (e === 'auth') {
            auth.logout();
          }
          //TODO wire up some user-viewable error message
        });
    }
  },
  render() {
    var createdOrUpdated = this.props.template.updatedAt
      ? this.props.template.updatedAt
      : this.props.template.createdAt;
    createdOrUpdated = helpers.dateTimeToString(createdOrUpdated);

    return (
      <li className="flex flex-col gap-3 items-center md:flex-row md:justify-between">
        <div className="flex flex-row md:basis-1/2">
          <div className="exerciseTemplateListItem icon">
            {Icons.getExerciseIcon(this.props.template.type)}
          </div>
          <div className="text-wrap">
            <strong>
              {helpers.shortenString(this.props.template.name, 75)}
            </strong>
            <br />
            <ul>{getSummaryItems(this.props.template.summary)}</ul>
          </div>
        </div>

        <div className="text-gray-400 md:basis-1/3 md:text-left">
          <label>{createdOrUpdated}</label>
        </div>
        <div className="flex flex-row gap-3 md:basis-1/12 md:justify-end">
          <Link
            className="icon-edit text-gray-400"
            to={
              '/admin/exercise-library/' +
              this.props.template.id +
              '/edit/' +
              this.props.influencerId
            }
          ></Link>
          <a
            className="actionLink icon-trash text-gray-400"
            onClick={() => this.deleteExerciseTemplate(this.props.template.id)}
          ></a>
        </div>
      </li>
    );
  },
});

function getSummaryItems(summary) {
  if (!summary) {
    return <li key={0}></li>;
  } else {
    var i = 0;
    return _.map(summary, (s) => {
      let str = helpers.shortenString(s, 75);
      return <li key={i++}>{str}</li>;
    });
  }
}

const ExerciseTemplateListWrapper = (props) => {
  const influencerId = props.params.influencerId
    ? props.params.influencerId
    : auth.getUser().influencerId;

  const { data, loading } = useQuery(GET_INFLUENCER, {
    variables: { id: parseInt(influencerId) },
  });
  return (
    <ExerciseTemplateList
      isLoading={loading}
      influencer={data ? data.creator : null}
      {...props}
    />
  );
};

export default ExerciseTemplateListWrapper;
